var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCmm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 466.667,
    height: 466.667,
    viewBox: "0 0 350 350",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1620 3095v-285H840V1420l115 57 115 58v975h667l6-97c4-54 7-153 7-220v-122l40-32c32-26 40-39 40-66 0-18 5-33 10-33 6 0 10-22 10-50 0-27 5-50 10-50 6 0 10 23 10 50 0 38 4 50 15 50 10 0 15 10 15 34 0 28 8 40 45 70l45 37v429h660v-810H1593l-584-290-584-289 924-1h924l176 123c97 68 182 127 189 131 9 5 12-5 12-43v-50l-162-112c-90-62-164-113-165-114-4-2 35-856 39-860 1-2 193 144 425 324l422 326 1 408c0 324-3 407-12 401-7-4-79-52-160-106s-150-98-153-98-5 21-5 48v47l108 75 107 75-114 3-114 3 7 554 7 555h-771v570h-490v-285z",
    style: {
      fill: "#fff"
    },
    transform: "matrix(.1 0 0 -.1 0 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 1003c0-24 38-873 40-880 0-2 441-3 980-3h981l-6 98c-6 103-35 752-35 790v22H280v-27z",
    style: {
      fill: "#fff"
    },
    transform: "matrix(.1 0 0 -.1 0 350)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmm);
export default __webpack_public_path__ + "static/media/cmm.fd1f7db064d454360a0396efe2d82e87.svg";
export { ForwardRef as ReactComponent };